/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import {
  DeleteMappingRuleMutation,
  useDeleteMappingRuleMutation,
} from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteMappingRule({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deleteMappingRuleMutation, { client, ...rest }] =
    useDeleteMappingRuleMutation({
      onCompleted: (data: DeleteMappingRuleMutation) => {
        if (data.deleteMappingRule) {
          onSuccess();
          removeFromApolloCache(
            client.cache,
            `MappingRule:${id}`,
            "mappingRules"
          );
        } else {
          showError();
        }
      },
    });

  async function deleteMappingRule(mappingRuleId: string) {
    setId(mappingRuleId);
    await deleteMappingRuleMutation({
      variables: {
        id: mappingRuleId,
      },
    });
  }

  return [deleteMappingRule, { client, ...rest }] as const;
}
